import React, { useState } from "react";

import { Field, FieldArray } from "formik";

import {
  Box,
  Text,
  HStack,
  VStack,
  FormControl,
  Icon,
  Input,
  Flex,
} from "@chakra-ui/react";

import { IoTrash } from "react-icons/io5";
import { AiOutlinePlusCircle } from "react-icons/ai";

import { hoursMinutes as hoursMask } from "../../../../../utils/masks";
import ErrorMessage from "../../../../../components/CustomErrorMessage";
import { PopoverHorario } from "../../../../../components/PopoverHorario";
import { TimePickerPopover } from "../../../../../components/TimePickerPopover";

const DiaHorario = ({ fieldName, title, mt, formProps, isVisualizacao }) => {
  const [popoverOpenStart, setPopoverOpenStart] = useState({});
  const [popoverOpenEnd, setPopoverOpenEnd] = useState({});

  const handleTimeSelectStart = (time, index) => {
    setPopoverOpenStart((prevState) => ({ ...prevState, [index]: false }));
    formProps.setFieldValue(`${fieldName}[${index}].start`, time);
  };

  const handleTimeSelectEnd = (time, index) => {
    setPopoverOpenEnd((prevState) => ({ ...prevState, [index]: false }));
    formProps.setFieldValue(`${fieldName}[${index}].end`, time);
  };

  return (
    <FieldArray name={fieldName}>
      {(arrayHelpers) => (
        <Box mt={mt ? mt : "2px"} w="100%">
          <Flex
            alignItems="flex-start"
            w="100%"
            flexDir={{ base: "column", sm: "row" }}
          >
            <Text
              w={{ base: "100px", lg: "150px" }}
              color="#5F6377"
              fontWeight="500"
              fontSize="14px"
              lineHeight="19.6px"
              mt="12px"
            >
              {title}
            </Text>
            <VStack
              ml={{ base: "0px", sm: "10px" }}
              mt={{ base: "10px", sm: "0px" }}
              alignItems="flex-start"
            >
              {formProps.values[fieldName] &&
              formProps.values[fieldName].length > 0 ? (
                formProps.values[fieldName].map((horario, index) => (
                  <Box key={`${fieldName}-${index}`}>
                    <HStack spacing="10px" alignItems="center">
                      <Field name={`${fieldName}[${index}].start`}>
                        {({ field, form }) => (
                          <FormControl
                            id={`${fieldName}[${index}].start`}
                            w="100px"
                          >
                            <Input
                              {...field}
                              isDisabled={isVisualizacao}
                              h="42px"
                              maxLength={5}
                              name={`${fieldName}[${index}].start`}
                              id={`${fieldName}[${index}].start`}
                              placeholder={isVisualizacao ? "" : "00:00"}
                              backgroundColor="#fff"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              onChange={(e) => {
                                formProps.setFieldValue(
                                  `${fieldName}[${index}].start`,
                                  hoursMask(e.target.value)
                                );
                              }}
                            />
                            <Box position={"absolute"} top={"3"} right="2">
                              <PopoverHorario
                                isVisualizacao={isVisualizacao}
                                popoverOpen={popoverOpenStart[index] || false}
                                setPopoverOpen={(isOpen) =>
                                  setPopoverOpenStart((prevState) => ({
                                    ...prevState,
                                    [index]: isOpen,
                                  }))
                                }
                              >
                                {popoverOpenStart[index] && (
                                  <TimePickerPopover
                                    onSelect={(time) =>
                                      handleTimeSelectStart(time, index)
                                    }
                                    onClose={() =>
                                      setPopoverOpenStart((prevState) => ({
                                        ...prevState,
                                        [index]: false,
                                      }))
                                    }
                                  />
                                )}
                              </PopoverHorario>
                            </Box>
                          </FormControl>
                        )}
                      </Field>
                      <Text
                        color="#5F6377"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="19.6px"
                      >
                        até
                      </Text>
                      <Field name={`${fieldName}[${index}].end`}>
                        {({ field, form }) => (
                          <FormControl
                            id={`${fieldName}[${index}].end`}
                            w="100px"
                          >
                            <Input
                              {...field}
                              isDisabled={isVisualizacao}
                              h="42px"
                              maxLength={5}
                              name={`${fieldName}[${index}].end`}
                              id={`${fieldName}[${index}].end`}
                              placeholder={isVisualizacao ? "" : "00:00"}
                              backgroundColor="#fff"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              onChange={(e) => {
                                formProps.setFieldValue(
                                  `${fieldName}[${index}].end`,
                                  hoursMask(e.target.value)
                                );
                              }}
                            />
                            <Box position={"absolute"} top={"3"} right="2">
                              <PopoverHorario
                                isVisualizacao={isVisualizacao}
                                popoverOpen={popoverOpenEnd[index] || false}
                                setPopoverOpen={(isOpen) =>
                                  setPopoverOpenEnd((prevState) => ({
                                    ...prevState,
                                    [index]: isOpen,
                                  }))
                                }
                              >
                                {popoverOpenEnd[index] && (
                                  <TimePickerPopover
                                    onSelect={(time) =>
                                      handleTimeSelectEnd(time, index)
                                    }
                                    onClose={() =>
                                      setPopoverOpenEnd((prevState) => ({
                                        ...prevState,
                                        [index]: false,
                                      }))
                                    }
                                  />
                                )}
                              </PopoverHorario>
                            </Box>
                          </FormControl>
                        )}
                      </Field>
                      <Icon
                        d={isVisualizacao ? "none" : "block"}
                        aria-label="Excluir horario"
                        color="#9EA1AE"
                        as={IoTrash}
                        boxSize="25px"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => arrayHelpers.remove(index)}
                      />
                      <Icon
                        d={
                          formProps.values[fieldName].length - 1 === index &&
                          !isVisualizacao
                            ? "block"
                            : "none"
                        }
                        aria-label="Adicionar horario"
                        color="#9EA1AE"
                        as={AiOutlinePlusCircle}
                        boxSize="25px"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => {
                          arrayHelpers.push({
                            nomeDiaSemana: fieldName,
                            start: "",
                            end: "",
                            id: 0,
                          });
                        }}
                      />
                    </HStack>
                    <HStack
                      spacing="40px"
                      alignItems="center"
                      mt="8px"
                      w="100%"
                    >
                      <Text
                        w="80px"
                        color="#e53e3e"
                        fontSize="14px"
                        whiteSpace={"nowrap"}
                      >
                        <ErrorMessage name={`${fieldName}[${index}].start`} />
                      </Text>
                      <Text
                        w="80px"
                        color="#e53e3e"
                        fontSize="14px"
                        whiteSpace={"nowrap"}
                      >
                        <ErrorMessage name={`${fieldName}[${index}].end`} />
                      </Text>
                    </HStack>
                  </Box>
                ))
              ) : (
                <Icon
                  d={isVisualizacao ? "none" : "block"}
                  aria-label="Adicionar horario"
                  color="#9EA1AE"
                  as={AiOutlinePlusCircle}
                  boxSize="25px"
                  mt="10px"
                  _hover={{ cursor: "pointer" }}
                  onClick={() => {
                    arrayHelpers.push({
                      nomeDiaSemana: fieldName,
                      start: "",
                      end: "",
                      id: 0,
                    });
                  }}
                />
              )}
            </VStack>
          </Flex>
        </Box>
      )}
    </FieldArray>
  );
};

export default DiaHorario;
